// Get Month Name By Index
import i18n from '@/libs/i18n'
import { getToken } from './auth'
import store from '../store/index'
// const Diff = require('diff');

export function getMonth(num) {
  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December']
  return months[num]
}

export function getUrl(business_id, service_id, image) {
  return `https://auston.fekracomputers.net/api/businesses/${business_id}/services/${service_id}/image/${image}`
}

export function getMessageFile(message_id) {
  const token = getToken().replace('Bearer ', '')
  return `https://auston.fekracomputers.net/api/messages/${message_id}/file/direct?token=${token}`
}

export function camelCase(arr) {
  return arr.replace('_', ' ').replace(/\s(.)/g, $1 => $1.toUpperCase()).replace(arr[0], arr[0].toUpperCase())
}

export function toLocalDatetime(input, lang = 'ar', time = false) {
  const datetime = new Date(input)
  datetime.getTimezoneOffset()
  if (time) {
    return datetime.toLocaleTimeString(`${lang == 'ar' ? 'ar-EG-u-nu-latn' : 'en-US'}`, { year: 'numeric', month: 'short', day: 'numeric' })
  }
  return datetime.toLocaleDateString(`${lang == 'ar' ? 'ar-EG-u-nu-latn' : 'en-US'}`, { year: 'numeric', month: 'short', day: 'numeric' })
}

export function formatDatetime(input, lang = 'ar', time = false) {
  const datetime = new Date(input)
  // datetime.setMinutes(datetime.getMinutes() - datetime.getTimezoneOffset())
  datetime.getTimezoneOffset()
  if (time) {
    return datetime.toLocaleTimeString(`${lang == 'ar' ? 'ar-EG-u-nu-latn' : 'en-US'}`, { year: 'numeric', month: 'numeric', day: 'numeric' })
  }
  return datetime.toLocaleDateString(`${lang == 'ar' ? 'ar-EG-u-nu-latn' : 'en-US'}`, { year: 'numeric', month: 'numeric', day: 'numeric' })
}

export function getUserPhoto(id) {
  return `https://auston.fekracomputers.net/api/user/${id}/photo`
}

export function capitalize(str) {
  if (typeof str !== 'string') return ''
  return str.charAt(0).toUpperCase() + str.slice(1)
}

export function getRandomColor() {
  const letters = '0123456789ABCDEF'
  let color = '#'
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)]
  }
  return color
}
export function compare(oldReport, newReport) {
  const dif = ' '
  const info = { text: String, ratio: 0 }
  const total = newReport.split(' ').length
  const changes = 0
  // Diff.diffWords(oldReport, newReport).forEach((part) => {
  //     dif += part.added ? `<ins style="text-decoration: none; color: #00796B;background: #E0F2F1">${part.value+' '}</ins>` :
  //         part.removed ? `<del style="color: #b30000;background: #fadad7">${part.value+' '}</del>`:`<span>${part.value+' '}</span>` ;
  //     changes++;
  // });
  // let total = changes + quotation;
  info.text = dif
  info.ratio = ((total - changes) / total) * 100
  return info
}

/**
 * Debounce function to delay execution
 * @param {Function} func - Function to debounce
 * @param {number} wait - Wait time in milliseconds
 * @returns {Function} Debounced function
 */
export function debounce(func, wait) {
  let timeout
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout)
      func(...args)
    }
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
  }
}

/**
 * Translate validation error messages from backend
 * @param {string} message - Error message from backend
 * @returns {string} Translated error message
 */
export function translateValidationError(message) {
  if (!message) return message

  // Common validation error patterns
  const validationPatterns = {
    // Required field errors
    'The name field is required': 'validation.messages.The name field is required',
    'The email field is required': 'validation.messages.The email field is required',
    'The password field is required': 'validation.messages.The password field is required',
    'The customer_id field is required': 'validation.messages.The customer_id field is required',

    // Email errors
    'The email must be a valid email address': 'validation.email',
    'The email field must be a valid email': 'validation.email',

    // Password errors
    'The password field is required': 'auth.errors.password_required',
    'The Password field is required': 'auth.errors.The Password field is required',
    'The Email field is required': 'auth.errors.The Email field is required',
  }

  // Check for direct matches
  if (validationPatterns[message]) {
    const translated = i18n.t(validationPatterns[message])
    if (translated && translated !== validationPatterns[message]) {
      return translated
    }
  }

  // Check for pattern matches (e.g., "The {field} field is required")
  const requiredPattern = /^The (.+) field is required\.?$/i
  const requiredMatch = message.match(requiredPattern)
  if (requiredMatch) {
    const fieldName = requiredMatch[1].toLowerCase()
    // Try to get the translated field name
    const translatedField = i18n.t(`common.${fieldName}`)
    if (translatedField && translatedField !== `common.${fieldName}`) {
      return i18n.t('validation.required', { _field_: translatedField })
    }
    return i18n.t('validation.required', { _field_: fieldName })
  }

  // Check for min length errors
  const minPattern = /^The (.+) must be at least (\d+) characters\.?$/i
  const minMatch = message.match(minPattern)
  if (minMatch) {
    const fieldName = minMatch[1].toLowerCase()
    const length = minMatch[2]
    const translatedField = i18n.t(`common.${fieldName}`)
    return i18n.t('validation.min', {
      _field_: translatedField !== `common.${fieldName}` ? translatedField : fieldName,
      length,
    })
  }

  // Check for max length errors
  const maxPattern = /^The (.+) may not be greater than (\d+) characters\.?$/i
  const maxMatch = message.match(maxPattern)
  if (maxMatch) {
    const fieldName = maxMatch[1].toLowerCase()
    const length = maxMatch[2]
    const translatedField = i18n.t(`common.${fieldName}`)
    return i18n.t('validation.max', {
      _field_: translatedField !== `common.${fieldName}` ? translatedField : fieldName,
      length,
    })
  }

  // Return original message if no translation found
  return message
}

/**
 * Translate validation errors object from backend
 * @param {Object} errors - Errors object from backend (e.g., { email: ['error1', 'error2'] })
 * @returns {Object} Translated errors object
 */
export function translateValidationErrors(errors) {
  if (!errors || typeof errors !== 'object') return errors

  const translatedErrors = {}
  for (const field in errors) {
    if (Array.isArray(errors[field])) {
      translatedErrors[field] = errors[field].map(msg => translateValidationError(msg))
    } else if (typeof errors[field] === 'string') {
      translatedErrors[field] = translateValidationError(errors[field])
    } else {
      translatedErrors[field] = errors[field]
    }
  }
  return translatedErrors
}
